/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class LoginService {
    public static $inject = [
        '$resource',
    ];
        constructor(private $resource: ng.resource.IResourceService,) {
        this.authRes = $resource('/api/auth/login', {}, {
            login: {
                method: 'POST'
            }
        });
    }


    public auth = (params: any) => {
        return this.authRes.login(params).$promise;
    };

    public logout = () => {
        // amplitude.logEvent('Logout')
        let logoutRes: any = this.$resource('/api/auth/logout\\/', {}, {});
        return logoutRes.get();
    };

    private authRes;
}

angular.module('beneple.global')
    .service('Login', LoginService);



// WEBPACK FOOTER //
// ./frontend/scripts/global/services/login.service.ts